import { User } from '@/entities/user';
import { apiClient, ApiError } from '@/shared/api';

export async function getUserApi(): Promise<User | null> {
  try {
    return await apiClient<User>(`user`);
  } catch (error) {
    if (error instanceof ApiError && error.status === 403) {
      return null;
    }

    throw error;
  }
}

interface UpdateUserParams extends Partial<User> {
  password?: string;
  password_confirmation?: string;
}

export async function updateUserApi(params: UpdateUserParams) {
  return await apiClient<User>(`user`, {
    method: 'POST',
    body: JSON.stringify(params),
  });
}
